import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { Formik, useFormikContext } from 'formik'
import FormContainer from '../../../components/Form/FormContainer'
import { FileMutationDto } from '../../../config/fileConfig'
import useUsers from '../../../hooks/useUsers'
import { UserDto, UserStatus } from '../../../config/userConfig'
import { UserTierAction } from './UserTierList'
import { UserTierDialogProps } from '../../Dialog/UserTier/UserTierDialog'
import { BaseTierDto } from '../../../config/finance/financeConfig'

export type UserTierFormProps<T extends BaseTierDto> = UserTierDialogProps<T> & {
    onSubmit: any
}

export default function UserTierForm<T extends BaseTierDto>(props: UserTierFormProps<T>): ReactElement {
    const fileContext = useFormikContext<FileMutationDto>()
    const { values } = useFormikContext<FileMutationDto>()
    const selectedUserIds = values.tiers.map(tier => tier.userId)
    const { users } = useUsers()

    const selectableUsers = useMemo(() => {
        return users
            .filter(user => user.status === UserStatus.Enabled)
            .filter(
                user =>
                    !selectedUserIds.includes(user.id) ||
                    (props.action === UserTierAction.EDIT && user.id === values.tiers[props.index].userId),
            )
            .sort((a: UserDto, b: UserDto) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()))
    }, [])

    return (
        <Formik<T> initialValues={props.initialValues} onSubmit={props.onSubmit}>
            <FormContainer>{props.createTierFormContainer(props, fileContext, selectableUsers)}</FormContainer>
        </Formik>
    )
}
